// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHeaderFull_container__2Ry-w","photographer":"PageHeaderFull_photographer__2Je1h"};